import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

import { PlanGroupCategoryEnum } from 'settings/_planGroupSettings'

interface Response {
  data: {
    plan_groups: PlanGroupResponse[]
  }
}

interface PlanGroupResponse {
  code: string,
  name: string,
  category: string,
  logo_url?: string
  self_register: boolean
  use_atena: boolean
  plans: Array<{
    code: string
    id: number
    is_particular: boolean
    name: string
  }>
}

export interface PlanGroup {
  code: string,
  name: string,
  category: PlanGroupCategoryEnum,
  logo_url?: string
  self_register?: boolean
  use_atena: boolean
  plans?: Array<{
    code: string
    id: number
    is_particular: boolean
    name: string
  }>
}

interface Error {
  response: {
    status: number
  }
}

export const listPlanGroups = (): Promise<PlanGroup[]> => {

  const endpoint = apiEndpoints.PLANS_GROUPS

  return new Promise<PlanGroup[]> ((resolve, reject) => {
    axios.get(endpoint)
      .then((response: Response) => {
        const planGroups = response.data.plan_groups.map(planGroup => {
          return {
            code: planGroup.code,
            name: planGroup.name,
            category: planGroup.category,
            plans: planGroup.plans,
            logo_url: planGroup.logo_url,
            self_register: planGroup.self_register,
            use_atena: planGroup.use_atena
          } as PlanGroup
        })

        resolve(planGroups)
      })
      .catch((error: Error) => {
        reject(error.response?.status)
      })
  })
}
